import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Observable } from 'rxjs';
import { DamageReason } from '../modules/mobilephone/models/equipment-api.model';
import { RegisterMobilbytteBytteResponse, RegisterMobilbytteBytteRequest } from '../models/mobilbytte-bytte.model';

@Injectable({
  providedIn: 'root',
})
export class EquipmentServiceV2 {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v2/equipment';

  getDamageReasons(): Observable<DamageReason[]> {
    const apiUrl = `${this.apiUrl}/redemption/damage-reasons`;
    return this.http.get<DamageReason[]>(apiUrl);
  }

  registerMobilbytteBytte(
    createRedemptionWithAssessment: RegisterMobilbytteBytteRequest
  ): Observable<RegisterMobilbytteBytteResponse> {
    const url = `${this.apiUrl}/redemption/grading-assessment`;
    return this.http.post<RegisterMobilbytteBytteResponse>(url, createRedemptionWithAssessment);
  }

  validateImei(agreementId: string, imei: string): Observable<boolean> {
    const apiUrl = `${this.apiUrl}/redemption/validate-imei?agreementId=${agreementId}&imei=${imei}`;
    return this.http.get<boolean>(apiUrl, { headers: { 'cache-control': 'no-cache' } });
  }
}
